import React from "react";
import { Avatar, Heading, VStack, WrapItem } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import Typical from "react-typical"

const greeting = "Hello, I am Rai!";

//Avatar, Heading and VStack components
const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    backgroundColor="teal"
    w='100%'
    maxWidth="1280px"
    id='top'
  >
  <VStack spacing={16}>
    <VStack spacing={4} alignItems="center">
      <WrapItem>
        <Avatar className='Avatar' name='Rai' size='2xl' src='MyPic1.png' />
      </WrapItem>
      <Heading as='h4' size='md'>{greeting}</Heading>
    </VStack>
    <VStack spacing={6}>
      <Heading as='h1' size='2xl'>enthusiastic</Heading>
      <Heading as='h1' size='2xl'>
        <Typical loop={1} steps={[
          "3D artist",
          50,
          "creative dev",
          50,
          "frontend dev",
          50
          ]}
        />
      </Heading>
    </VStack>
  </VStack>
  </FullScreenSection>
)

export default LandingSection;
